import * as Result from "@gordonb/result/result";
import { renderUrl } from "../../util/route.ts";
import {
  type LibraryNoteOptionResult,
  LibraryNoteOptionResultSchema,
  type LibraryNoteTeaserArrayResult,
  LibraryNoteTeaserArrayResultSchema,
} from "../../models/library-note.ts";
import { toBearerToken } from "../../util/bearer-token.ts";
import { LIBRARY_NOTES_API_URL } from "../client-config.ts";

export type SearchLibraryNotesParams = {
  query?: string;
  type?: string;
  limit?: number;
  truncateContent?: boolean;
};

/**
 * Search library notes
 */
export const searchLibraryNotes = async ({
  token = undefined,
  query,
  type,
  limit,
  truncateContent,
}: {
  token?: string;
  query?: string;
  type?: string;
  limit?: number;
  truncateContent?: boolean;
}): Promise<LibraryNoteTeaserArrayResult> => {
  if (!token) {
    return Result.err("Authorization token required");
  }

  const params: Record<string, string | number | boolean> = {};
  if (query !== undefined) params.query = query;
  if (type !== undefined) params.type = type;
  if (limit !== undefined) params.limit = limit;
  if (truncateContent !== undefined) params.truncateContent = truncateContent;

  const url = renderUrl({
    base: globalThis.location.origin,
    path: LIBRARY_NOTES_API_URL,
    query: params,
  });

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        authorization: toBearerToken(token),
      },
    });
    const json = await response.json();
    return LibraryNoteTeaserArrayResultSchema.parse(json);
  } catch (error) {
    return Result.err((error as Error).message);
  }
};

/**
 * Get a single library note by slug
 */
export const getLibraryNote = async ({
  token = undefined,
  slug,
}: {
  token?: string;
  slug: string;
}): Promise<LibraryNoteOptionResult> => {
  if (!token) {
    return Result.err("Authorization token required");
  }

  const url = renderUrl({
    base: globalThis.location.origin,
    path: `${LIBRARY_NOTES_API_URL}/:slug`,
    params: { slug },
  });

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        authorization: toBearerToken(token),
      },
    });
    const json = await response.json();
    return LibraryNoteOptionResultSchema.parse(json);
  } catch (error) {
    return Result.err((error as Error).message);
  }
};
